import React from 'react'

function OptionalBackToMap({unmount, updateUnmount, togglePopUp}) {
    return (
        <>
            <p>
                If you return to the map you will lose your progress on this location.
                <br /><br />
                Do you want to continue?
                <br /><br />
            </p>
            <div>
                <button 
                    className='infoPopUp_btn' 
                    onClick={() => updateUnmount({name: 'waiting', state: true})}
                >
                    {unmount.waiting ? 'Loading Map' : 'Back To Map'}
                </button>
                <button className='infoPopUp_btn' onClick={togglePopUp}>Stay Here</button>
            </div>
        </>
    )
}

export default OptionalBackToMap